import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import PayslipList from "./pages/PayslipList";
import DailySheet from "./pages/DailySheet";
import ChangePassword from "./pages/ChangePassword";
import Holidays from "./pages/Holidays";
import EmpDashboard from "./pages/EmpDashboard";
import RequireEmpAuth from "./RequireEmpAuth";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/payslips"
          element={
            <RequireEmpAuth>
              <PayslipList />
            </RequireEmpAuth>
          }
        />
        <Route
          path="/daily-sheet"
          element={
            <RequireEmpAuth>
              <DailySheet />
            </RequireEmpAuth>
          }
        />
        <Route
          path="/holidays"
          element={
            <RequireEmpAuth>
              <Holidays />
            </RequireEmpAuth>
          }
        />
        <Route
          path="/change-password"
          element={
            <RequireEmpAuth>
              <ChangePassword />
            </RequireEmpAuth>
          }
        />
        <Route
          path="/dashboard"
          element={
            <RequireEmpAuth>
              <EmpDashboard />
            </RequireEmpAuth>
          }
        />
        <Route
          path="*"
          element={<EmpDashboard />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
